export default "__VITE_ASSET__CY3osG_y__"